import React, {Fragment} from 'react'
import { Field } from 'redux-form'

import Collapse from '@material-ui/core/Collapse/index'

import { BkFlowSelect } from '../../elements/BkFlowSelect'
import { BkFlowInput } from '../../elements/BkFlowInput'
import{ BkFlowCheckbox } from '../../elements/BkFlowCheckbox'
import { BkFlowTextArea } from '../../elements/BkFlowTextArea'
import { CountrySelectField } from '../elements/CountrySelectField'
import StateProvSelectField from '../elements/StateProvSelectField'

import yn from 'yn'
import _ from 'lodash'

const GuestFormDefault = props => {
	const {
		formPrefixes,
		hotelLabels,
		privacyPolicyLink,
		requestsEvent,
		requestsExpanded,
		stateProvinceData,
	} = props

	return (
		<form className="guest-form">
			<div className="u-form-group">
				{ yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_PREFIX) &&
					!_.isEmpty(formPrefixes) &&
					<Field
						name="prefix"
						type="text"
						size="xxs"
						component={ BkFlowSelect }
						label={ hotelLabels.prefix ? hotelLabels.prefix : 'Prefix' }
						required={ yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_PREFIX_REQUIRED) ? true : false }
						options={ formPrefixes }
					/>
				}

				<Field
					name="firstName"
					type="text"
					size={ yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_PREFIX) ? 'md' : 'lg' }
					component={ BkFlowInput }
					required={ true }
					label={ hotelLabels.firstName ? hotelLabels.firstName : 'First Name' }
				/>
				<Field
					name="lastName"
					type="text"
					size={ yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_PREFIX) ? 'md' : 'lg' }
					component={BkFlowInput}
					required={ true }
					label={ hotelLabels.lastName ? hotelLabels.lastName : 'Last Name' }
				/>
			</div>

			<div className="u-form-group group-email">
				<Field
					name="email"
					type="email"
					size="xl"
					component={ BkFlowInput }
					label={ hotelLabels.email }
					required={ true }
					labelLink={ privacyPolicyLink }
					labelLinkText={ hotelLabels.valuePrivacy ? hotelLabels.valuePrivacy : 'We value your privacy' }
				/>
			</div>

			{ process.env.REACT_APP_COMPONENT_GUEST_FORM_EMAIL_CONSENT === 'default' &&
				<div className="u-form-group group-email-consent">
					<Field
						name="emailOptIn"
						type="checkbox"
						size="xl"
						component={ BkFlowCheckbox }
						required={ false }
						label={ hotelLabels.emailOptIn ? hotelLabels.emailOptIn : 'I want to receive property and stay notifications' }
					/>
				</div>
			}

			<div className="u-form-group group-phone">
				<Field
					name="phone"
					type="tel"
					size="sm"
					component={ BkFlowInput }
					required={ true }
					label={ hotelLabels.phoneNumber ? hotelLabels.phoneNumber : 'Phone Number' }
				/>
			</div>

			{ process.env.REACT_APP_COMPONENT_GUEST_FORM_SMS_CONSENT === 'default' &&
				<div className="u-form-group group-sms-consent">
					<Field
						name="textOptIn"
						type="checkbox"
						size="xl"
						component={ BkFlowCheckbox }
						required={ false }
						label={ hotelLabels.textConsent ? hotelLabels.textConsent : 'I consent to receive text notifications' }
					/>
				</div>
			}

			{ yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_ADDRESS_PRIMARY) &&
				<div className="u-form-group group-address">
					<Field
						name="address1"
						type="text"
						size="xl"
						component={BkFlowInput}
						required={ yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_ADDRESS_REQUIRED) ? true : false }
						label={hotelLabels.address ? hotelLabels.address : 'Address'}
					/>
				</div>
			}

			{ yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_ADDRESS_SECONDARY) &&
				<div className="u-form-group group-address-alt">
					<Field
						name="address2"
						type="text"
						size="xl"
						component={BkFlowInput}
						required={true}
						label={hotelLabels.address + ' 2'}
					/>
				</div>
			}

			{ yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_CITY_TOWN) &&
				<div className="u-form-group group-city">
					<Field
						name="city"
						type="text"
						size="lg"
						component={BkFlowInput}
						required={ yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_CITY_TOWN_REQUIRED) ? true : false }
						label={ hotelLabels.cityTown ? hotelLabels.cityTown : 'City / Town' }
					/>
				</div>
			}

			{ yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_COUNTRY) &&
				<div className="u-form-group group-country">
					<Field
						name="country"
						size="md"
						component={ CountrySelectField }
						label={ hotelLabels && hotelLabels.country ? hotelLabels.country : 'Country' }
						required={ yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_COUNTRY_REQUIRED) ? true : false }
					/>
				</div>
			}

			{ yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_STATE_PROVINCE) &&
				stateProvinceData &&
				!_.isEmpty(stateProvinceData) &&
					<div className="u-form-group group-state-prov">
						<Field
							name="stateProv"
							size="md"
							component={ StateProvSelectField }
							required={ yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_STATE_PROVINCE_REQUIRED) ? true : false }
							label={ hotelLabels.stateProvince ? hotelLabels.stateProvince : 'State / Province' }
							stateProvinceData={ stateProvinceData }
						/>
					</div>
			}

			{ yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_IATA) &&
				<div className="u-form-group group-iata">
					<Field
						name="travelAgentCode"
						type="text"
						size="md"
						component={ BkFlowInput }
						required={ false }
						label={ hotelLabels.travelAgentCode ? hotelLabels.travelAgentCode : 'Travel Agent Code' }
					/>
				</div>
			}

			{ yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_SPECIAL_REQUESTS_ACCORDION) ?
				<div className="u-form-group group-requests">
					<Collapse
						className="u-form__accordion"
						in={requestsExpanded}
						timeout={300}
					>
						<Field
							name="comments"
							size="xxl"
							component={BkFlowTextArea}
							label={ hotelLabels.specialRequests ? hotelLabels.specialRequests : 'Special Requests' }
						/>
					</Collapse>

					<div className="u-form-group group-requests-button">
						<div
							className="btn btn-primary"
							onClick={ requestsEvent }
						>
							{ hotelLabels.specialRequests ? hotelLabels.specialRequests : 'Special Requests' }
							{ requestsExpanded ?
								<Fragment>&nbsp;&#45;</Fragment>
							:
								<Fragment>&nbsp;&#43;</Fragment>
							}
						</div>
					</div>
				</div>
			:
				<div className="u-form-group group-request-content">
					<Field
						name="comments"
						size="xl"
						component={BkFlowTextArea}
						label={ hotelLabels.specialRequests ? hotelLabels.specialRequests : 'Special Requests' }
					/>
				</div>
			}
		</form>
	)
}

export default GuestFormDefault


// WEBPACK FOOTER //
// ./src/components/forms/guestForm/layouts/GuestFormDefault.js